module.exports = __webpack_public_path__ + "static/img/right.029b2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1